import { render, staticRenderFns } from "./SendRequestTab.vue?vue&type=template&id=6ab11848&scoped=true&lang=pug"
import script from "./SendRequestTab.vue?vue&type=script&lang=ts"
export * from "./SendRequestTab.vue?vue&type=script&lang=ts"
import style0 from "./SendRequestTab.vue?vue&type=style&index=0&id=6ab11848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab11848",
  null
  
)

export default component.exports